<template>
    <div>
        <van-nav-bar    left-text="返回" @click-left="back"    left-arrow/>            
        <div class='pt46'>
                <van-cell-group title='历史气象数据'>
                <van-cell title="年份" :value="searchYear" is-link @click='countDaypicker = true'></van-cell>
        </van-cell-group>
        </div>
        <div style="position:absolute;top: 130px;left: 0;right: 0;bottom: 0;overflow:auto">
            <div  class='antV_charts' style="width:100%">
       			<canvas id="charts1"  style="width:100%;height:200px"></canvas>
                <p>月累计降水/mm</p>
     	    </div>
            <div  class='antV_charts' style="width:100%">
       			<canvas id="charts2"  style="width:100%;height:200px"></canvas>
                <p>月平均温度/℃</p>
     	    </div>
             <div  class='antV_charts' style="width:100%">
       			<canvas id="charts3"  style="width:100%;height:200px"></canvas>
                <p>月平均气压/Pa</p>
     	    </div>
             <div  class='antV_charts' style="width:100%">
       			<canvas id="charts4"  style="width:100%;height:200px"></canvas>
                <p>月相对湿度</p>
     	    </div>
             <div  class='antV_charts' style="width:100%">
       			<canvas id="charts5"  style="width:100%;height:200px"></canvas>
                <p>月积温</p>
     	    </div>
        </div>
        

        <van-popup  v-model="countDaypicker"  position='bottom' get-container='body'>
            <van-picker :columns="searchYearLis" @cancel='countDaypicker = false'  @change="countDaypickerChange" @confirm='countDaypickerConfirm'  show-toolbar  :default-index="0" />
        </van-popup>
    </div>
</template>
<script>
import {getHistoryData} from '@/request/data'
import F2 from "@antv/f2/lib/index-all";
export default {
    name:'historyData',
    data() {
        return {
            
            historyYearList:[],
            title:'',
            data1:[],
            data2:[],
            data3:[],
            data4:[],
            data5:[],
            searchYearLis:[],
            countDaypicker:false,
            searchYear:'',
            SearchYearNum:'',
        }
    },
    mounted() {
        this.setYear()
    },
    methods: {
        setYear(){
            //循环10年
            let year = new Date().getFullYear();        
            this.searchYearLis = []
            for (let i = 1; i < 10; i++) {            
                let y = year - i           
                this.searchYearLis.push(y)            
            }
            this.searchYear = this.searchYearLis[0]
            this.addTable()
        },

        addTable(){
            this.$toast({
                type:'loading',
                mask:true,
                forbidClick:true,
                duration:0
            });
            let data = {}
            data.lat = this.$route.query.lat
            data.lon = this.$route.query.lon
            data.num = this.searchYearLis[0] - this.searchYear + 1
            console.log(data.num)
            this.data1 = []
            this.data2 = []
            this.data3 = []
            this.data4 = []
            this.data5 = []
            getHistoryData(data).then(res=>{
                console.log(res.data.data.weather)
                if (res.data.code == 0) {                    
                    for (let i = 0; i < res.data.data.weather.length; i++) {
                        let data1 = {}
                        data1.month = (i+1)
                        // data1.name = '累计降水/mm'
                        data1.value = res.data.data.weather[i].pre_sum
                        this.data1.push(data1)
                        
                        let data2 = {}
                        data2.month = (i+1)
                        // data2.name = '平均温度/℃'
                        data2.value = res.data.data.weather[i].tmp_avg
                        this.data2.push(data2)

                        let data3 = {}
                        data3.month = (i+1)
                        // data3.name = '平均气压/Pa'
                        data3.value = res.data.data.weather[i].prs_avg
                        this.data3.push(data3)

                        let data4 = {}
                        data4.month = (i+1)
                        // data4.name = '相对湿度'
                        data4.value = res.data.data.weather[i].rhf_avg
                        this.data4.push(data4)

                        let data5 = {}
                        data5.month = (i+1)
                        // data5.name = '积温'
                        data5.value = res.data.data.weather[i].tem_acc
                        this.data5.push(data5)
                    }
                    this.addCharts1()
                    this.addCharts2()
                    this.addCharts3()
                    this.addCharts4()
                    this.addCharts5()
                    // console.log(this.tableData)
                }
                this.$toast.clear()
            })
        },
        changeYear(value){            
            this.year = value 
            this.title = this.historyYearList[(value-1)].text
            this.addTable()
        },
        countDaypickerChange(picker, value, index){
            this.SearchYearNum = value;
            
        },
        countDaypickerConfirm(){
            this.searchYear = this.SearchYearNum
            this.countDaypicker = false
            this.addTable()
        },
        addCharts1(){
            let chart = new F2.Chart({
                id: 'charts1',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.data1,{
                month: {
                    min: 1,
                    max: 6,
                    formatter: function formatter(val) {                        
                        return val+'月';
                    }
                },
                
            });    
            //定义进度条
            chart.scrollBar({
                mode: 'x',
                xStyle: {
                    offsetY: -5
                }
            });
            this.data1.map(function(obj) {
                chart.guide().text({
                position: [obj.month, obj.value],
                content: obj.value,
                style: {
                    textBaseline: 'bottom',
                    textAlign: 'center'
                },
                offsetY: -2
                });
            });
            chart.interaction('pan');
            chart.line().position('month*value');
            chart.point().position('month*value').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();

        },
        addCharts2(){
            let chart = new F2.Chart({
                id: 'charts2',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.data2,{
                month: {
                    min: 1,
                    max: 6,
                    formatter: function formatter(val) {                        
                        return val+'月';
                    }
                },                    
            });    
            //定义进度条
            chart.scrollBar({
                mode: 'x',
                xStyle: {
                    offsetY: -5
                }
            });
            this.data2.map(function(obj) {
                chart.guide().text({
                position: [obj.month, obj.value],
                content: obj.value,
                style: {
                    textBaseline: 'bottom',
                    textAlign: 'center'
                },
                offsetY: -2
                });
            });
            chart.interaction('pan');
            chart.line().position('month*value');
            chart.point().position('month*value').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();

        },
        addCharts3(){
            let chart = new F2.Chart({
                id: 'charts3',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.data3,{
                month: {
                    min: 1,
                    max: 6,
                    formatter: function formatter(val) {                        
                        return val+'月';
                    }
                },      
            });    
            //定义进度条
            chart.scrollBar({
                mode: 'x',
                xStyle: {
                    offsetY: -5
                }
            });
            this.data3.map(function(obj) {
                chart.guide().text({
                position: [obj.month, obj.value],
                content: obj.value,
                style: {
                    textBaseline: 'bottom',
                    textAlign: 'center'
                },
                offsetY: -2
                });
            });
            chart.interaction('pan');
            chart.line().position('month*value');
            chart.point().position('month*value').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();

        },
        addCharts4(){
            let chart = new F2.Chart({
                id: 'charts4',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.data4,{
                month: {
                    min: 1,
                    max: 6,
                    formatter: function formatter(val) {                        
                        return val+'月';
                    }
                },      
            });    
            //定义进度条
            chart.scrollBar({
                mode: 'x',
                xStyle: {
                    offsetY: -5
                }
            });
            this.data4.map(function(obj) {
                chart.guide().text({
                position: [obj.month, obj.value],
                content: obj.value,
                style: {
                    textBaseline: 'bottom',
                    textAlign: 'center'
                },
                offsetY: -2
                });
            });
            chart.interaction('pan');
            chart.line().position('month*value');
            chart.point().position('month*value').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();

        },
        addCharts5(){
            let chart = new F2.Chart({
                id: 'charts5',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.data5,{
                month: {
                    min: 1,
                    max: 6,
                    formatter: function formatter(val) {                        
                        return val+'月';
                    }
                },      
            });    
            //定义进度条
            chart.scrollBar({
                mode: 'x',
                xStyle: {
                    offsetY: -5
                }
            });
            this.data5.map(function(obj) {
                chart.guide().text({
                position: [obj.month, obj.value],
                content: obj.value,
                style: {
                    textBaseline: 'bottom',
                    textAlign: 'center'
                },
                offsetY: -2
                });
            });
            chart.interaction('pan');
            chart.line().position('month*value');
            chart.point().position('month*value').style({
                stroke: '#fff',
                lineWidth: 1
            });
            chart.render();

        },
        back(){
            this.$router.go(-1)
        }
    },

}
</script>
<style  scoped>
.pt100{padding-top:100px}
.antV_charts{margin-bottom:15px}
.antV_charts p{font-size:12px;text-align:center;line-height:24px}
</style>